/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { ExportToolRequest } from '../types/ExportTool';
import type { ExportToolResponse } from '../types/ExportTool';

export type ExportToolsSetDefaultCreateRequest = ExportToolRequest;
export type ExportToolsSetDefaultCreateResponse = ExportToolResponse;

export type ExportToolsSetDefaultCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this export tool.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/export_tools/{id}/set_default/
 *
 * ```yaml
 * operationId: export_tools_set_default_create
 * tags:
 *   - export_tools
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ExportTool'
 *     description: ''
 * ```
 */
export const exportToolsSetDefaultCreateOperation = ({
  id,
  ...rest
}: ExportToolsSetDefaultCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/export_tools/${id}/set_default/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/export_tools/{id}/set_default/' };
  };

/**
 * POST /dmx-server/export_tools/{id}/set_default/
 *
 * ```yaml
 * operationId: export_tools_set_default_create
 * tags:
 *   - export_tools
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ExportTool'
 *     description: ''
 * ```
 */
export const exportToolsSetDefaultCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: ExportToolsSetDefaultCreateQuery;
  request: ExportToolRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<ExportToolResponse>> => {
  const operation = exportToolsSetDefaultCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
